import React, { useEffect, useState } from "react";
import { getDownloadURL, ref, listAll } from 'firebase/storage';
import { storage } from "../../../firebase/firebaseConfig"; // Asegúrate de que la configuración de Firebase Storage esté correcta
import { Box } from "@mui/material";

const ListaVideosPage = () => {
    const [videoUrls, setVideoUrls] = useState([]); // Estado para almacenar las URLs de los videos
    const [loading, setLoading] = useState(true);   // Estado para manejar la carga
    const [currentVideoIndex, setCurrentVideoIndex] = useState(0);  // Estado para gestionar el video actual
    const [isFading, setIsFading] = useState(false);  // Estado para manejar la transición de desvanecimiento

    // Función para obtener los videos desde Firebase Storage
    useEffect(() => {
        const fetchVideos = async () => {
            try {
                // Referencia a la carpeta de videos en Firebase Storage
                const listRef = ref(storage, 'misvideospagecalocho/');

                // Obtener todos los archivos de la carpeta
                const res = await listAll(listRef);

                // Obtener las URLs de cada archivo
                const urls = await Promise.all(
                    res.items.map(async (itemRef) => {
                        const url = await getDownloadURL(itemRef);
                        return url;
                    })
                );

                // Actualizar el estado con las URLs obtenidas
                setLoading(false);  // Finalizar la carga
                setVideoUrls(urls);
            } catch (error) {
                console.error('Error obteniendo los videos:', error);
            } 
        };

        fetchVideos();
    }, []); // Se ejecuta una vez cuando el componente se monta

    // Función que maneja la transición al finalizar el video
    const handleVideoEnded = () => {
        setIsFading(true);  // Comenzar la animación de desvanecimiento
        setTimeout(() => {
            // Pasar al siguiente video después del desvanecimiento
            if (currentVideoIndex < videoUrls.length - 1) {
            setCurrentVideoIndex(currentVideoIndex + 1);  // Ir al siguiente video
            } else {
            setCurrentVideoIndex(0);  // Reiniciar la lista si es el último video
            }
            setIsFading(false);  // Comenzar la animación de aparición
        }, 500);  // Duración de la transición en milisegundos
        };
      

    return (
      <Box
        sx={{
          width: { xs: '100%', sm: '80%', md: '600px' },
          height: { xs: '200px', sm: '400px', md: '600px' },
          overflow: 'hidden',
          justifyContent: 'center',
          alignItems: 'center',
          margin: '0 auto',
          border: '0.5px solid #f9f9f9',
          borderRadius: '5px',
          
        }}
      >
        {videoUrls.length > 0 && (
          <video
            src={videoUrls[currentVideoIndex]}
            autoPlay
            muted
            onEnded={handleVideoEnded}
            className={`video ${isFading ? 'fade-out' : 'fade-in'}`}  // Clase CSS para la transición
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
            }}
          />
        )}
      </Box>
    );
}

export default ListaVideosPage;